(function (angular) {
    'use strict';
    /**
     * This is the controller for the Activity Feed view. Don't be mislead by the name "analytics" in this codebase.
     */
    angular.module('GorillaBoy.Dashboard')
        .controller('DashboardController', [
            '$rootScope',
            '$scope',
            'SourceConstant',
            'AppConstants',
            '$translate',
            '$log',
            '$q',
            '$location',
            'DocumentService',
            'AnalyticsService',
            'MessageManager',
            'userInfo',
            DashboardController
        ]);

    function DashboardController($rootScope,
                                 $scope,
                                 SourceConstant,
                                 AppConstants,
                                 $translate,
                                 $log,
                                 $q,
                                 $location,
                                 DocumentService,
                                 AnalyticsService,
                                 MessageManager,
                                 userInfo) {

        document.title = $translate.instant('ANALYTICS.DASHBOARD.TITLE') + ' - ' + AppConstants.APP_NAME;
        var layoutViewTypes = AppConstants.LayoutViewTypes;
        var queryCategory = 'USER_ACTIVITIES';
        var minimumDate = new Date(2017, 1, 15); //Month index starts from zero. This is the date activities will be enabled in production
        $scope.queryFormData = {};

        //SECTION: Layout code
        $scope.layout = {
            queriedSearchFileName: "",
            partialContent: './dashboard/content_partial.html',
            partialTitleBar: './dashboard/title_bar.html',
            view: layoutViewTypes.VIEW_ANALYTICS_DASHBOARD_LAYOUT,

            hasRightSidebar: false,
            serviceError: false,
            searchInProgress: true,

            //Master copy of whether left sidebar should be shown/hidden.
            showLeftSidebar: $rootScope.showLeftSidebar,
            showFilterMenu: false,
            showRightSidebar: false,
            showUploadPane: false
        };

        function extractDesiredActivitiesFacetInfo(activityTypes) {
            var docVersionUploadedCount = 0,
                docShareCount = 0,
                docCommentedCount = 0,
                docDeleted = false;
            for (var k = 0; k < activityTypes.length; k++) {
                if (activityTypes[k].Value === 'DOCUMENT_VERSION_UPLOADED') {
                    docVersionUploadedCount = activityTypes[k].Count;
                }

                if (activityTypes[k].Value === 'DOCUMENT_SHARED') {
                    docShareCount = activityTypes[k].Count;
                }

                if (activityTypes[k].Value === 'DOCUMENT_COMMENT_ADDED' || activityTypes[k].Value === 'DOCUMENT_ANNOTATION_ADDED') {
                    docCommentedCount += activityTypes[k].Count;
                }

                if (activityTypes[k].Value === 'DOCUMENT_VERSION_DELETED') {
                    docDeleted = true;
                }
            }
            return {
                docVersionUploadedCount: docVersionUploadedCount,
                docShareCount: docShareCount,
                docCommentedCount: docCommentedCount,
                docDeleted:  docDeleted
            };
        }

        $scope.dateOptions = [{
            label: $translate.instant('ANALYTICS.FILTER.TIME.ANY_TIME'),
            value: 'ANY_TIME'
        }, {
            label: $translate.instant('ANALYTICS.FILTER.TIME.TODAY'),
            value: 'TODAY'
        }, {
            label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_7_DAYS'),
            value: 'LAST_SEVEN'
        }, {
            label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_30_DAYS'),
            value: 'LAST_THIRTY'
        }, {
            label: $translate.instant('ANALYTICS.FILTER.TIME.CUSTOM'),
            value: 'CUSTOM'
        }];

        $scope.datePickerOptions = {
            minDate: new Date(minimumDate)
        };

        $scope.setInitialStartDate = function () {
            if (!$scope.queryFormData.startDate) {
                var now = new Date();
                $scope.queryFormData.startDate = now;
            }
        };

        $scope.setInitialEndDate = function () {
            if (!$scope.queryFormData.endDate) {
                var now = new Date();
                $scope.queryFormData.endDate = now;
            }
        };

        $scope.showFilterMenu = function () {
            $scope.__queryFormDataCopy = angular.copy($scope.queryFormData);
            $scope.layout.showFilterMenu = !$scope.layout.showFilterMenu;
        };

        $scope.hideFilterMenu = function () {
           // $scope.__queryFormDataCopy = null;
            $scope.layout.showFilterMenu = !$scope.layout.showFilterMenu;
        };

        $scope.resetSearchForm = function () {
            $scope.queryFormData = {
                dateModified: 'ANY_TIME'
            };
        };

        $scope.applyFilter = function () {
            $scope.getAnalytics();
        };


        $scope.getDates = function() {
            var query = {},
                todayEarlyMorning,
                todayMidnight;
            todayEarlyMorning = new Date();
            todayEarlyMorning.setHours(0, 0, 0, 0);

            todayMidnight = new Date();
            todayMidnight.setHours(23, 59, 59, 999);
            if ($scope.queryFormData.dateModified === 'TODAY') {
                query.From = todayEarlyMorning;
                query.To = todayMidnight;
            } else if ($scope.queryFormData.dateModified === 'LAST_SEVEN') {
                query.From = new Date();
                query.From.setHours(0, 0, 0, 0);
                query.From.setDate(query.From.getDate() - 7);
            } else if ($scope.queryFormData.dateModified === 'LAST_THIRTY') {
                query.From = new Date();
                query.From.setHours(0, 0, 0, 0);
                query.From.setDate(query.From.getDate() - 30);
            } else if ($scope.queryFormData.dateModified === 'CUSTOM') {
                if ($scope.queryFormData.startDate) {
                    query.From = $scope.queryFormData.startDate;
                }
                if ($scope.queryFormData.endDate) {
                    query.To = $scope.queryFormData.endDate;
                }
            }

            if (!query.From) {
                query.From = minimumDate;
            }
            if (!query.To) {
                query.To = todayMidnight;
            }
            return query;
        };

        $scope.createInitialQuery = function () {
            var unifiedSearchQuery = {};
            angular.extend(unifiedSearchQuery, $scope.getDates());
            unifiedSearchQuery.ActivityTypes = ["DOCUMENT_VERSION_UPLOADED","DOCUMENT_SHARED","DOCUMENT_COMMENT_ADDED", "DOCUMENT_ANNOTATION_ADDED"];
            return unifiedSearchQuery;
        };

        $scope.getAnalytics = function () {

            $scope.layout.searchInProgress = true;
            $scope.__createFilterButtons();

            $scope.getAnalyticsHelper = function() {
                var params = {
                    queryCategory: queryCategory,
                    query: $scope.createInitialQuery(),
                    limit: 10
                };
                var deferred = $q.defer();
                return AnalyticsService.getAnalytics(params).then(function (response) {
                    deferred.resolve(angular.fromJson(response.data));
                    return deferred.promise;
                }, function (err) {
                    deferred.reject(err);
                    $log.error(err.message);
                    // promise is returned
                    return deferred.promise;
                });
            };
            $scope.getAnalyticsHelper().then(
                function (response) {

                    $scope.result = response;
                    var activityTypeFacets = response.Facets.ActivityType;
                    var resourceIdFacets = response.Facets.ResourceId;
                    var totalFacetCount = extractDesiredActivitiesFacetInfo(activityTypeFacets);

                    var promises = [];

                    // Query each resource to fetch facet information related to resource.
                    for (var j = 0; j < resourceIdFacets.length; j++) {
                        var querySingleResource = {};
                        angular.extend(querySingleResource, $scope.getDates());
                        querySingleResource.ResourceId = resourceIdFacets[j].Value;
                        var params = {
                            queryCategory: queryCategory,
                            query: querySingleResource,
                            limit: 1
                        };
                        var promise = AnalyticsService.getAnalytics(params);
                        promises.push(promise);
                    }

                    $q.all(promises).then(function (results) {
                        var arr = [];
                        for (var i = 0; i < results.length; i++) {

                            var data = angular.fromJson(results[i].data);
                            var activityTypes = data.Facets.ActivityType;
                            var resourceName = data.Items[0].Fields.ResourceName;
                            var resourceId = data.Items[0].Fields.ResourceId;
                            var facetCount = extractDesiredActivitiesFacetInfo(activityTypes);

                            arr.push({
                                resourceId: resourceId,
                                resourceName: resourceName,
                                docVersionUploadedCount: facetCount.docVersionUploadedCount,
                                docShareCount: facetCount.docShareCount,
                                docCommentedCount: facetCount.docCommentedCount,
                                docDeleted: facetCount.docDeleted
                            });
                        }

                        $scope.aggregatedResult = arr;
                        $scope.totalDocsUploaded = totalFacetCount.docVersionUploadedCount;
                        $scope.totalDocsShared = totalFacetCount.docShareCount;
                        $scope.totalDocsCommented = totalFacetCount.docCommentedCount;
                        $scope.layout.searchInProgress = false;
                    });
                },
                function (error) {
                    // handle errors here
                    console.log(error.statusText);
                }
            );
        };

        $scope.__createFilterButtons = function() {
            var queryFormData = $scope.queryFormData;
            $scope.filterButtons = [];
            if (queryFormData.dateModified === 'TODAY') {
                $scope.filterButtons.push({
                    label: $translate.instant('ANALYTICS.FILTER.TIME.TODAY')
                });
            } else if (queryFormData.dateModified === 'LAST_SEVEN') {
                $scope.filterButtons.push({
                    label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_7_DAYS')
                });
            } else if (queryFormData.dateModified === 'LAST_THIRTY') {
                $scope.filterButtons.push({
                    label: $translate.instant('ANALYTICS.FILTER.TIME.LAST_30_DAYS')
                });
            } else if (queryFormData.dateModified === 'CUSTOM') {

                if (queryFormData.endDate && queryFormData.startDate) {
                    $scope.filterButtons.push({
                        label : $translate.instant('ANALYTICS.FILTER.TIME.BETWEEN', {
                            From : moment(queryFormData.startDate).format('MM/DD/YYYY'),
                            To : moment(queryFormData.endDate).format('MM/DD/YYYY')
                        })
                    });
                } else if (queryFormData.endDate && !queryFormData.startDate) {
                    $scope.filterButtons.push({
                        label : $translate.instant('ANALYTICS.FILTER.TIME.BEFORE', {
                            To : moment(queryFormData.endDate).format('MM/DD/YYYY')
                        })
                    });
                } else if (!queryFormData.endDate && queryFormData.startDate) {
                    $scope.filterButtons.push({
                        label : $translate.instant('ANALYTICS.FILTER.TIME.AFTER', {
                            From : moment(queryFormData.startDate).format('MM/DD/YYYY')
                        })
                    });
                }
            }
        };

        $scope.removeFilter = function(type) {
            $scope.queryFormData.dateModified = 'ANY_TIME';
            $scope.getAnalytics();
        };

        $scope.resetSearchForm = function() {
            $scope.queryFormData = {
                dateModified: 'ANY_TIME'
            };
        };

        //A very big assumption, ResourceType field will always be either 'document' or 'folder'
        $scope.openDetail = function(resourceId) {
            $scope.resetSearchParams();
            $location.search('documentId', resourceId);
        };

        $scope.resetSearchForm();
        $scope.getAnalytics();

        $scope.openContainingFolder = function(resourceId) {
            var promise = DocumentService.getDocumentPath(resourceId);

            promise.then(function(response) {
                var data = response.data,
                    resourceId;

                if (!data || !data.Path || !data.Path.Components || !data.Path.Components[0] || !data.Path.Components[0].Id) {
                    $scope.__openContainingFolderFailureCallbackFn();
                    return;
                }
                //We should check the penultimate entry to access the parent folder ID
                resourceId = data.Path.Components[data.Path.Components.length - 2].Id;
                if (resourceId === userInfo.RootFolderId) {
                    $location.path('/mydocs');
                } else if (resourceId === userInfo.RecycleBinFolderId) {
                    $location.path('/recycle');
                } else if (resourceId) {
                    //fromSearch flag will make the user go to Shared With Me page if the folder cannot be loaded (if the user does not have access)
                    $location.url('/folder/' + resourceId + '?fromSearch=true');
                }
                return response;
            }, $scope.__openContainingFolderFailureCallbackFn);
        };

        $scope.__openContainingFolderFailureCallbackFn = function(response) {
            MessageManager.addErrorMessage($translate.instant('ANALYTICS.FILE_ACTIONS.OPEN_CONTAINING_FOLDER.ERROR'));
            return response;
        };

        $scope.documentUploadActivitiesQuery = function(resourceId, resourceName) {
            var query = {};
            query.activityTypes = ["DOCUMENT_VERSION_UPLOADED"];
            query.resourceId= resourceId;
            var datesObj = $scope.getDates();
            var url = "#/activities?documentId=" + encodeURIComponent(resourceId) + "&resourceName=" + encodeURIComponent(resourceName) + "&activityTypes=" + query.activityTypes + "&from=" + datesObj.From + "&to=" + datesObj.To;
            return url;
        };

        $scope.documentSharedQuery = function(resourceId, resourceName) {
            // &resourceName={{folder.Name}}
            var query = {};
            query.activityTypes = ["DOCUMENT_SHARED"];
            query.resourceId= resourceId;
            var datesObj = $scope.getDates();
            var url = "#/activities?documentId=" + encodeURIComponent(resourceId) + "&resourceName=" + encodeURIComponent(resourceName) + "&activityTypes=" + query.activityTypes + "&from=" + datesObj.From + "&to=" + datesObj.To;
            return url;
        };

        $scope.documentCommentsQuery = function(resourceId, resourceName) {
            var query = {};
            query.activityTypes = ["DOCUMENT_COMMENT_ADDED", "DOCUMENT_ANNOTATION_ADDED"];
            query.resourceId= resourceId;
            var datesObj = $scope.getDates();
            var url = "#/activities?documentId=" + encodeURIComponent(resourceId) + "&resourceName=" + encodeURIComponent(resourceName) + "&activityTypes=" + query.activityTypes + "&from=" + datesObj.From + "&to=" + datesObj.To;
            return url;
        };

        $scope.documentResourceQuery = function(resourceId) {
            var url = "#/document/" + encodeURIComponent(resourceId);
            return url;
        };
    }
}(angular));